import { GetContextMenuItemsParams, MenuItemDef } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { RecordingsGridRowDatum } from "components/RecordingsGrid/RecordingsGrid.types";
import { RefObject, useCallback } from "react";
import { exportAsCSV } from "utils/exportAsCSV";

// Override the default context menu items for AG-Grid to add a custom export as CSV option.
export const useRecordingsGridsGetContextMenuItems = <
  TData extends RecordingsGridRowDatum,
>(
  gridRef: RefObject<AgGridReact<TData>>,
  exportName?: string,
) => {
  return useCallback(
    (params: GetContextMenuItemsParams): (string | MenuItemDef)[] => {
      return [
        "copy",
        "copyWithHeaders",
        "copyWithGroupHeaders",
        "paste",
        "separator",
        {
          name: "Export as CSV",
          action: () => exportAsCSV(gridRef, exportName),
          icon: '<span class="ag-icon ag-icon-csv" unselectable="on" role="presentation"></span>',
        },
      ];
    },
    [gridRef, exportName],
  );
};
